import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useFieldglassJobPostingContextValue } from '../context/FieldglassJobPostingProvider'

export const FieldglassJobPostingHeader = () => {
  const { state, actions } = useFieldglassJobPostingContextValue()

  return (
    <Header
      title="Fieldglass Job Posting"
      rightContent={
        state.hasSearchParams ? (
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
        ) : null
      }
    />
  )
}
